import { BaseService } from "core/services";
import { FacilityOrderTemplateItemRouteService } from "application/facility-order/services";

class FacilityOrderTemplateItemService extends BaseService {
	constructor(apiClient) {
		super(apiClient, new FacilityOrderTemplateItemRouteService());
	}

    async putAsync(url, resource) {
		const connectionId = sessionStorage.getItem("connectionId");
		return await this.apiClient.put(url, resource, connectionId ? { connectionId: connectionId} : null);
    }

    async postAsync(url, resource) {
		const connectionId = sessionStorage.getItem("connectionId");
		return await this.apiClient.post(url, resource, connectionId ? { connectionId: connectionId} : null);
    }

    put(url, resource) {
		const connectionId = sessionStorage.getItem("connectionId");
		return this.apiClient.put(url, resource, connectionId ? { connectionId: connectionId} : null);
    }

    post(url, resource) {
		const connectionId = sessionStorage.getItem("connectionId");
		return this.apiClient.post(url, resource, connectionId ? { connectionId: connectionId} : null);
    }

    create(resource) {
        const url = this.routeService.create(resource);
        return this.post(url, resource);
    }

    update(resource) {
        const url = this.routeService.update(resource);
        return this.put(url, resource);
    }

    async calculateQuantity(resource) {
        const url = this.routeService.calculateQuantity(resource);
        const response = await this.putAsync(url, resource);
        return response.data || null;
    }

    async calculateQuantityNewFlow(resource) {
        const url = this.routeService.calculateQuantityNewFlow(resource);
        const response = await this.putAsync(url, resource);
        return response.data || null;
    }

    async recalculateQuantityNewFlow(resource) {
        const url = this.routeService.recalculateQuantityNewFlow(resource);
        const response = await this.putAsync(url, resource);
        return response.data || null;
    }

    async createAdditionalItems(resource) {		
		const url = this.routeService.createAdditionalItems(resource);
        const response = await this.postAsync(url, resource);
        return response.data || null;
	}

    async createAdditionalItemsNewFlow(resource) {	
		const url = this.routeService.createAdditionalItemsNewFlow(resource);
        const response = await this.postAsync(url, resource);
        return  response.data || null;
	}
   
    async createAdditionalTrachItemsNewFlow(resource) {		
		const url = this.routeService.createAdditionalTrachItemsNewFlow(resource);
        const response = await this.postAsync(url, resource);
        return response.data || null;
	}

    async newUpdate(resource) {
        const url = this.routeService.newUpdate(resource);
        const response = await this.putAsync(url, resource);
        return response.data || null;
    }

    async newFlowUpdate(resource) {
        const url = this.routeService.newFlowUpdate(resource);
        return this.put(url, resource);
    }

    async newDelete(resource) {    
        const url = this.routeService.newDelete(resource);
        const connectionId = sessionStorage.getItem("connectionId");
        const response = await this.apiClient.delete(url, connectionId ? { connectionId: connectionId} : null, resource);
        return response;
    }

    batchUpdateSendSeparatelyQty(resources) {
        const url = this.routeService.batchUpdateSendSeparatelyQty(resources);
        return this.put(url, resources)
    }
    
    findAndReplaceItem(resource){
        const url = this.routeService.findAndReplaceItem(resource);
		return this.put(url, resource);
	}
 
    findAndDeleteItem(resource){
        const url = this.routeService.findAndDeleteItem(resource);
		return this.put(url, resource);
	}

    calculateReplacementItemsQuantity(resources){
        const url = this.routeService.calculateReplacementItemsQuantity(resources);
        return this.put(url, resources)
    }

    getOrderSummaryItems(filter) {
        const url = this.routeService.getOrderSummaryItems(filter);
        return this.apiClient.get(url);
    }

    cutbackSalesOrderQuantities(resource) {
        const connectionId = sessionStorage.getItem("connectionId");
		const url = this.routeService.cutbackSalesOrderQuantities(resource);
		return this.put(url, resource, connectionId ? { connectionId: connectionId} : null);
	}

    updateSendSeparatelyQuantity(resource) {
        const connectionId = sessionStorage.getItem("connectionId");
		const url = this.routeService.updateSendSeparatelyQuantity(resource);
		return this.put(url, resource, connectionId ? { connectionId: connectionId} : null);
	}

    updateBatchSendSeparatelyQuantity(resource) {
        const connectionId = sessionStorage.getItem("connectionId");
		const url = this.routeService.updateBatchSendSeparatelyQuantity(resource);
		return this.put(url, resource, connectionId ? { connectionId: connectionId} : null);
	}

    roundToTheNearestCase(resource) {
        const connectionId = sessionStorage.getItem("connectionId");
		const url = this.routeService.roundToTheNearestCase(resource);
		return this.put(url, resource, connectionId ? { connectionId: connectionId} : null);
	}

    updateIncludeNotCurrentTube(resources) {
        const url = this.routeService.updateIncludeNotCurrentTube(resources);
        return this.apiClient.put(url, resources)
    }
}

export default FacilityOrderTemplateItemService;